import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Button } from "components";
import { NameId } from "types";

import PendDetails from "./index";

import styles from "../pend.module.scss";

type PendDetailsWithAddBtnType = {
	id: string;
	nameId: NameId;
	urlPendPage: string;
	urlAddPendPage: string;
};

const PendDetailsWithAddBtn = ({
	id,
	nameId,
	urlPendPage,
	urlAddPendPage,
}: PendDetailsWithAddBtnType) => {
	const history = useHistory();

	const redirectToAddPendPage = useCallback(() => {
		history.push(urlAddPendPage);
	}, [urlAddPendPage, history]);

	return (
		<>
			<div className={styles.buttonsContainer}>
				<Button
					value="Add pend"
					variant="primary"
					onClick={redirectToAddPendPage}
				/>
			</div>
			<PendDetails id={id} nameId={nameId} urlPendPage={urlPendPage} />
		</>
	);
};

export default PendDetailsWithAddBtn;
